(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypePatientProcessController', TypePatientProcessController);

    TypePatientProcessController.$inject = ['TypePatientProcess', 'CoreService', 'GenericEntityDatatableService', '$q',
        '$uibModal', 'ConfirmationService'];

    function TypePatientProcessController(TypePatientProcess, CoreService, GenericEntityDatatableService, $q,
                                          $uibModal, ConfirmationService) {
        var vm = this;

        var params = {
            id: CoreService.getCurrentFacility().id
        }

        var entityStateName = 'type-patient-process'

        vm.descriptor = {
            title: 'Patient Process',
            entityClassHumanized: 'Patient Process',
            entityStateName: entityStateName,
            service: TypePatientProcess,
            serviceMethod: 'byFacility',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'xrder',
                    title: 'Order'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Patient Process',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-patient-process/update/type-patient-process-dialog.html',
                controller: 'TypePatientProcessDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ["CoreService", function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-patient-process/update/type-patient-process-dialog.html',
                controller: 'TypePatientProcessDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypePatientProcess', function (TypePatientProcess) {
                        return TypePatientProcess.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Patient Process').result.then(function () {
                    TypePatientProcess.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
